import React from 'react'
import { Link } from 'react-router-dom'
import './LegalFooter.css'

/**
 * LegalFooter component for displaying Terms and Privacy links on landing page
 * Ensures compliance with data protection laws (GDPR, CCPA) by making policies
 * accessible before user registration
 */
function LegalFooter() {
  return (
    <footer className="legal-footer" aria-label="Site footer">
      <div className="legal-footer-content">
        <p className="legal-footer-heading">ServeSync, Inc.</p>
        <p className="legal-footer-text">
          Contact: support@servesynctennis.com
          <br />
          Address: 6233 Summit Trl, Peachtree Corners, GA 30092
        </p>
        <nav className="legal-footer-links" aria-label="Legal and SMS policies">
          <Link to="/privacy-policy" className="legal-link">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="legal-link">
            Terms of Service
          </Link>
          <Link to="/sms-notifications-disclosure" className="legal-link">
            SMS Notifications &amp; Opt-In Policy
          </Link>
        </nav>
      </div>
    </footer>
  )
}

export default LegalFooter
